import { getInstitutions, getRoles } from "../../api/common";
import { createSliceWithThunks } from "../utils";

const initialState = {
  institutions: {
    data: null,
    status: "idle",
    error: null,
  },
  roles: {
    data: null,
    status: "idle",
    error: null,
  },
};

export const commonSlice = createSliceWithThunks({
  name: "commonSlice",
  initialState: initialState,
  reducers: (create) => ({
    resetStateCommon: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    //* thunks

    fetchInstitutions: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getInstitutions(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.institutions.status = "loading";
        },
        rejected: (state, action) => {
          state.institutions.status = "failed";
          state.institutions.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            if (data?.type === "success") {
              state.institutions.data = data?.data;
            } else {
              state.institutions.error = {
                message: data?.data || data?.message || "An error occurred",
              };
            }
          } else {
            state.institutions.error = {
              message: data?.data || data?.message || "An error occurred",
            };
          }
          state.institutions.status = "idle";
        },
      }
    ),
    fetchRoles: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getRoles(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.roles.status = "loading";
        },
        rejected: (state, action) => {
          state.roles.status = "failed";
          state.roles.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            if (data?.type === "success") {
              state.roles.data = data?.data;
            } else {
              state.roles.error = {
                message: data?.data || data?.message || "An error occurred",
              };
            }
          } else {
            state.roles.error = {
              message: data?.data || data?.message || "An error occurred",
            };
          }
          state.roles.status = "idle";
        },
      }
    ),
  }),
});

export const { resetStateCommon, fetchInstitutions, fetchRoles } =
  commonSlice.actions;
export default commonSlice.reducer;
